import { getCohortTiming } from "components/mentorship/CohortExperience"
import type { Milestone } from "components/mentorship/MilestonesTimeline"

type ProgramCardProps = {
  startDate: Date | null
  endDate: Date | null
  milestones: Milestone[]
  onEditDates: () => void
}

const formatDate = (date: Date) => date.toLocaleDateString("en-US", { month: "short", day: "numeric" })

export function ProgramCard({ startDate, endDate, milestones, onEditDates }: ProgramCardProps) {
  const timing = getCohortTiming(startDate, endDate)
  const nextMilestone = milestones
    .map((milestone) => ({ ...milestone, parsedDate: milestone.date instanceof Date ? milestone.date : new Date(milestone.date) }))
    .filter((milestone) => !Number.isNaN(milestone.parsedDate.getTime()) && milestone.parsedDate.getTime() >= Date.now())
    .sort((first, second) => first.parsedDate.getTime() - second.parsedDate.getTime())[0]

  return (
    <section className="cohort-open-section min-w-0" aria-labelledby="cohort-program-heading">
      <div className="cohort-card-heading">
        <h2 id="cohort-program-heading" className="text-[19px] sm:text-xl">Program</h2>
      </div>
      {timing.state === "missing" ? (
        <div className="py-3.5">
          <p className="text-[15px] leading-6">Start and end dates haven&apos;t been set for this cohort.</p>
          <p className="mt-1 text-sm text-[var(--cohort-ink-muted)]">Set the program dates to show its timeline.</p>
        </div>
      ) : (
        <div>
          <div className="flex min-h-[52px] items-center justify-between gap-4 border-b border-[var(--cohort-rule-soft)] py-3">
            <span className="text-[15px]">Timeline</span>
            <span className="text-right text-sm text-[var(--cohort-ink-muted)]">{timing.label}</span>
          </div>
          <div className="flex min-h-[52px] items-center justify-between gap-4 border-b border-[var(--cohort-rule-soft)] py-3">
            <span className="text-[15px]">Next milestone</span>
            <span className="text-right text-sm text-[var(--cohort-ink-muted)]">{nextMilestone ? `${nextMilestone.name}, ${formatDate(nextMilestone.parsedDate)}` : "None scheduled"}</span>
          </div>
          <div className="flex min-h-[52px] items-center justify-between gap-4 py-3">
            <span className="text-[15px]">Milestones set</span>
            <span className="text-right text-sm text-[var(--cohort-ink-muted)]">{milestones.length} dated</span>
          </div>
        </div>
      )}
      <button type="button" onClick={onEditDates} className="cohort-text-action min-h-11 text-[15px]">{timing.state === "missing" ? "Set program dates" : "Edit program dates"}</button>
    </section>
  )
}
